"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingContainer = exports.InnerWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("@nib-components/theme");
const styles_1 = require("../../styles");
exports.Wrapper = styled_components_1.default.div`
  ${styles_1.mixins.square("100%")}
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme_1.colorWhite};
  z-index: 1;
`;
exports.InnerWrapper = styled_components_1.default.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;
exports.LoadingContainer = styled_components_1.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  margin: 10px 0 100px;

  * {
    font-family: inherit;
  }
`;